import { request } from '../request';
/* 处方相关接口 */
const prescription = {
  list: (data) => request('/api/customer/prescription', 'get', data),
  add: (data) => request('/api/customer/prescription', 'post', data),
  update: (data) => request(`/api/customer/prescription/${data.id}`, 'put', data),
  delete: (id) => request(`/api/customer/prescription/${id}`, 'delete', {}, { successMsg: true }),
};
/* 收藏(心愿单)相关接口 */
const wish = {
  /* 获取心愿单列表的数据 */
  getWishList: (data) => request('/api/customer/wish', 'get', data),
  addWish: (data) =>
    request('/api/customer/wish', 'post', data, {
      successMsg: true,
      errorMsg: true,
    }),
  delWish: (data) =>
    request('/api/customer/wish', 'del', data, {
      successMsg: true,
      errorMsg: true,
    }),
  add: (data) => request('/api/customer/wish', 'post', data, { successMsg: true, errorMsg: true }),
  delete: (data) =>
    request('/api/customer/wish', 'delete', data, { successMsg: true, errorMsg: true }),
  // 获取用户收藏的商品ID列表, 不分页
  allWishIds: () =>
    request('/api/customer/wish/product_ids', 'get', {}, { successMsg: false, errorMsg: false }),
};
/* 地址接口 */
const address = {
  list: (data) => request('/api/customer/address', 'get', data),
  add: (data) => request('/api/customer/address', 'post', data),
  update: (data) => request(`/api/customer/address/${data.id}`, 'put', data),
  set_default: (data) => request(`/api/customer/default_address/${data.id}`, 'put', {}),
  delete: (data) => request(`/api/customer/address/${data.id}`, 'delete', {}, { successMsg: true }),
};
/* 账户信息 */
const info = {
  get: () => request('/api/customer/account', 'get'),
  set: (data, flag = true) => request('/api/customer/account', 'put', data, { successMsg: flag }),
  setNoMessage: (data) => request('/api/customer/account', 'put', data),
};
/* 邀请用户 */
const refer = {
  /* 获取邀请信息 */
  getInviteRegister: () => request('/api/customer/invite_register', 'get'),
  /* 邀请记录列表 */
  getInviteLog: (data) => request('/api/customer/invite_log', 'get', data),
  /* 发送邀请邮件 */
  sendInviteEmail: (data) =>
    request('/api/customer/invite_email', 'post', data, { successMsg: true, errorMsg: false }),
};

/* 客服咨询 */
const tickets = {
  /* 获取客服咨询列表 */
  getTicketsList: () => request('/api/customer/tickets_zendesk', 'get'),
  /* 提交售后问题 */
  postAfterSale: (data) => request('/api/customer/after_sale', 'post', data),
  /* 提交投诉建议 */
  postComplaint: (data) => request('/api/customer/complaint', 'post', data),
  /* 获取用户订单列表 */
  getOrderList: () => request('/api/order/lists', 'get'),
};

/* 用户积分相关 */
const point = {
  /* 获取用户积分列表 */
  getPointList: (data) => request('/api/customer/point', 'get', data),
  /* 获取用户积分汇总 */
  getPointInfo: () => request('/api/customer/point_info', 'get'),
  // 用户分享添加积分
  addShare: (data) => request('/api/customer/add_share_point', 'post', data),
  // 获取积分规则
  crmPointRule: () => request('/api/public/crm_point', 'get'),
  // 积分任务
  pointTaskList: () => request('/api/customer/point_task', 'get'),
};

/* 浏览记录相关 */
const read = {
  /* 获取用户浏览记录列表 */
  getReadLogList: (data) => request('/api/customer/read_log_list', 'get', data),
  /* 删除浏览记录 */
  delReadLog: (data) => request('/api/customer/del_read_log', 'del', data),
};
/* 会员权益相关 */
const vipEquity = {
  /* 获取会员权益 */
  getVipEquity: (data) => request('/api/customer/vip_equity', 'get', data),
  // 创建vip订单
  vipCreate: (data) => request('/api/customer/vip_create', 'post', data),
};

/* 评论相关 */
const reviews = {
  /* 从订单列表中获取未评论的列表 */
  getToBeCommentedList: (data) => request('/api/order/lists', 'get', data),
  /* 从订单列表中获取【已评论】的列表 */
  getCommentedList: () => request('/api/order/review', 'get'),
  /* 发表评论 */
  postCommented: (data) => request('/api/order/review', 'post', data),
  /** 获取评论可得优惠券信息 */
  reviewCoupon: () => request('/api/order/review_coupon', 'post'),
};

/* 用户信息验证相关 */
const verifi = {
  /* 验证邮箱 发送验证邮件 */
  sendVerifiEmail: (data) => request('/api/customer/binding_email_send_email', 'get', data), // , { errorMsg: false }
  /* 验证邮箱 绑定邮箱 */
  bindEmail: (data) => request('/api/customer/binding_email', 'post', data, { successMsg: true }),
  /* 验证手机号 发送验证短信 */
  sendBindPhoneSms: (data) => request('/api/customer/binding_telephone_send', 'get', data), // , { errorMsg: false }
  /* 验证手机号 绑定手机号 */
  bindPhone: (data) =>
    request('/api/customer/binding_telephone', 'post', data, { successMsg: true }),
  // 更换邮箱
  // 验证密码接口(目前用于修改邮箱前的账户验证)
  checkPassword: (data) =>
    request('/api/customer/check_password', 'post', data, {
      successMsg: false,
      errorMsg: false,
    }),
  // 发送修改邮箱验证码
  sendEmailCode: (data) => request('/api/customer/change_email_send_verify', 'post', data),
  // 修改邮箱
  changeEmail: (data) =>
    request('/api/customer/change_email', 'post', data, { successMsg: false, errorMsg: false }),
};
/* 会员中心相关 */
const member = {
  /* 设置会员礼-生日 */
  setGiftBirthday: (data) =>
    request('/api/customer/member/set_gift_birthday', 'post', data, { successMsg: true }),
  /* 退会 */
  quitMember: () => request('/api/customer/member/quit', 'post', {}, { successMsg: true }),
  /* 入会 */
  joinMember: () => request('/api/customer/member/join', 'post', {}, { successMsg: true }),
  /* 获取会员等级权益列表 */
  getMemberPrivileges: () => request('/api/customer/member/privileges', 'get'),
  /* 获取会员礼包领取记录列表 */
  getMemberRewards: (data) => request('/api/customer/member/rewards', 'get', data),
  /* 获取会员入会礼包领取记录列表 */
  getJoinMemberReward: () => request('/api/customer/member/join_member_reward', 'get'),
  /* 获取会员权益弹框中，会员价订单的列表 */
  getMemberOrder: (data) => request('/api/customer/member/member_order', 'get', data),
  /* 获取会员成长值记录列表 */
  getMemberScoreLog: (data) => request('/api/customer/member/score_log', 'get', data),
  /** 会员等级权益(升级弹框用) */
  privilegesMerge: (data) => request('/api/customer/member/privileges_merge', 'get', data),
  /* 会员等级列表（不登录可访问） */
  getMemberLevels: () => request('/api/customer/member/levels', 'get'),
};

const wallet = {
  // 钱包日志
  getWalletLog: (data) =>
    request('/api/customer/wallet_log', 'get', data, { successMsg: false, errorMsg: false }),
  // 获取所有币种钱包余额和最后使用的钱包币种
  getWalletBalance: (data) =>
    request('/api/customer/wallet_balance', 'get', data, { successMsg: false, errorMsg: false }),
};

// 动作触发频次
const action = {
  // 用户动作触发次数，包含本次触发
  triggerAction: (data) =>
    request('/api/customer/trigger_action', 'post', data, { successMsg: false, errorMsg: false }),
};

// 问卷
const survey = {
  // 用户动作触发次数，包含本次触发
  getSurveyList: () =>
    request(
      '/api/customer/get_customer_survey_list',
      'get',
      {},
      {
        successMsg: false,
        errorMsg: false,
      },
    ),
  startAnswerQuestion: (data) => request('/api/customer/start_answering_questions', 'post', data),
  submitQuestion: (data) =>
    request('/api/customer/submit_questionnaire', 'post', data, {
      successMsg: false,
    }),
  getSurveyPop: (data) =>
    request('/api/customer/get_survey_pop', 'get', data, { successMsg: false, errorMsg: false }),
};
// 支付中台
const paymentCenter = {
  cardList: () => request('/api/pay_center/customers/cards', 'get'),
  delCard: ({ cart_id, password }) =>
    request(
      `/api/pay_center/customers/cards/${cart_id}`,
      'delete',
      { password },
      { successMsg: true },
    ),
};

// 塞券弹窗
const plugTicket = {
  // 用户动作触发次数，包含本次触发
  getPlugCoupons: (data) =>
    request('/api/customer/alert', 'post', data, { successMsg: false, errorMsg: false }),
};

export default {
  prescription,
  wish,
  address,
  info,
  refer,
  tickets,
  point,
  read,
  vipEquity,
  reviews,
  verifi,
  member,
  wallet,
  action,
  survey,
  paymentCenter,
  plugTicket,
};
